import { assetUrl } from '@/lib/asset-url';
import { cn } from '@/lib/utils';

type TdcLogoPlaceholderProps = {
  className?: string;
  size?: 'sm' | 'md';
};

const LOGO_SRC = 'brand/tdc-logo.png';

/**
 * Official Tour De Cure lockup. Rendered on a transparent/white field —
 * never recolour the mark.
 */
export function TdcLogoPlaceholder({ className, size = 'sm' }: TdcLogoPlaceholderProps) {
  return (
    <img
      src={assetUrl(LOGO_SRC)}
      alt="Tour De Cure"
      className={cn(
        'block w-auto object-contain object-left',
        size === 'sm' && 'h-9 sm:h-10',
        size === 'md' && 'h-12 sm:h-14',
        className
      )}
    />
  );
}
